import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { useDispatch } from 'react-redux';

import { Stack, TextField, IconButton, InputAdornment, } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { showError, showSuccess, } from '../../../utils/toast';
import { useDeleteAccountMutation } from '../../../redux/login/LoginServices';
import Iconify from '../../../components/iconify';

export default function DeleteForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [DeleteAccount, DeleteAccountData] = useDeleteAccountMutation()

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('UserName is required'),
    password: Yup.string().required('Password is required'),
  });


  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      DeleteAccount({
        username: values.username,
        password: values.password
      })
      setIsLoading(true);
    }
  });


  const { errors, touched, values, setValues, handleChange, handleSubmit, getFieldProps } = formik;

  useEffect(() => {

      console.log('DeleteAccountData', DeleteAccountData)

    if (DeleteAccountData.isError) {
      setIsLoading(false)
      showError(DeleteAccountData.error?.data?.msg || 'Invalid username or password');
      DeleteAccountData.reset();
      formik.resetForm()
    } else if (DeleteAccountData.isSuccess) {
      setIsLoading(false)
      showSuccess(DeleteAccountData.data?.msg || "Account is deleted successfully!")
      DeleteAccountData.reset();
      formik.resetForm()
    }
  }, [DeleteAccountData, dispatch, formik, navigate, setValues])




  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              autoComplete="username"
              label="User Name"
              value={values.username}
              onChange={handleChange}
              {...getFieldProps('username')}
              error={Boolean(touched.username && errors.username)}
              helperText={touched.username && errors.username}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              {...getFieldProps('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
            />
          </Stack>

          <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ mt: 2 }} loading={isLoading}>
            Delete Account
          </LoadingButton>
        </Form>
      </FormikProvider>
    </>
  );
}
